import { IUpdateAssistenciaTecnicaUseCase } from "../../../presentation/useCases/update/update_assistencia_tecnica_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateAssistenciaTecnicaUseCase
 */

export class UpdateAssistenciaTecnicaUseCase implements IUpdateAssistenciaTecnicaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updateAssistenciaTecnica(
    idAssistenciaTecnica: number,
    codigo: string | null,
    tipo: number | null,
    centroCusto: number | null,
    cliente: string | null,
    idClienteCentroCusto: number | null,
    unidade: string | null,
    dataAbertura: Date | null,
    contato: string | null,
    previsaoRealizacaoVistoria: Date | null,
    prioridade: number | null,
    previsaoTerminoAssistencia: Date | null,
    reclamacao: string | null,
    procedente: number | null,
    dataReparo: Date | null,
    taxa: number | null,
    taxaCliente: number | null,
    valorTaxa: number | null,
    resolvido: number | null,
    dataEncerramento: Date | null,
    observacoes: string | null,
    custo: number | null,
    nroChamado: string | null,
    acoesCorretivas: string | null,
    clienteCadastrado: boolean | null,
    statusAssistencia: number | null,
    categorias: {
      idCategoriaAssistencia: number | null;
      nomeCategoria: string | null;
      ativo: boolean | null;
    }[] | null,
  ): Promise<void> {
    await this.repository.updateAssistenciaTecnica(
      idAssistenciaTecnica,
      codigo,
      tipo,
      centroCusto,
      cliente,
      idClienteCentroCusto,
      unidade,
      dataAbertura,
      contato,
      previsaoRealizacaoVistoria,
      prioridade,
      previsaoTerminoAssistencia,
      reclamacao,
      procedente,
      dataReparo,
      taxa !== null ? taxa === 1 : null,
      taxaCliente !== null ? taxaCliente === 1 : null,
      valorTaxa,
      resolvido,
      dataEncerramento,
      observacoes,
      custo,
      nroChamado,
      acoesCorretivas,
      clienteCadastrado,
      statusAssistencia,
      categorias,
    );
  }
}
